<script lang="ts">
  import Caret from "~icons/ph/caret-down";
</script>

<details>
  <summary>How was the gross amount determined?<Caret /></summary>
  <p>
    The gross amount of compensation was a result of a process of negotiation between us, easyJet and their lawyers that
    took 8 months to conclude. Ultimately easyJet were willing to agree a lump sum of money to settle all of the claims
    of clients who had instructed JLG. This figure included damages, costs and disbursements, but not insurance as that
    is not recoverable from the other side. A lump sum figure was negotiated and this figure was split between all of
    our clients.
  </p>
  <p>
    The settlement itself has been backed by senior counsel who advised that, under all the circumstances, the claims
    were not only worth the amount agreed but there was also a risk that easyJet may successfully defend against any
    claims on the basis that it was itself a victim of a sophisticated cyber-attack, designed to infiltrate the highest
    level of data security. The settlement was also approved by the Claimant Committee that was created to make
    decisions such as the approval of settlement offers on behalf of all claimants.
  </p>
  <p>
    Under the circumstances, the settlement represents a good end result for a matter that has taken over 6 years to
    conclude.
  </p>
</details>
